import { render, staticRenderFns } from "./AdminTabelloneEsportaView.vue?vue&type=template&id=875835b8&"
import script from "./AdminTabelloneEsportaView.vue?vue&type=script&lang=ts&"
export * from "./AdminTabelloneEsportaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports